export const enum HttpResponseTypeEnum {
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  AccessDenied = 403,
}
